<template>
  <modal :show="isModalVisible" @close="isModalVisible = false" class="prompt-modal" :persist="!isComplete">
    <div class="alert alert-danger mb-0 mt-3" v-if="false && !resetToken">
      <!-- we dont check resetToken anymore -->
      Invite expired. Please click on the original invite link to continue.
    </div>
    <template v-else>
      <div class="modal-header">
        <h2 class="m-0">
          {{ isComplete ? "You're All Done!" : 'Welcome to Refera' }}
        </h2>
      </div>
      <div class="modal-body d-flex pb-0">
        <div v-if="!isComplete">
          <div class="alert alert-warning d-md-none">
            <b>Limited functionality on mobile</b>
            <br />Try Chrome on desktop for all features
          </div>
          <p class="m-0 mb-3 font-weight-bold" style="width: 95%">
            Please tell us your practice owner's name and choose a secure password for future access:
          </p>
          <!-- <div class="row">
          <div class="col">
            <b>Username:</b>
            {{user.email}}
          </div>
          </div>-->
          <div class="form-group">
            <label>Owner Doctor First Name</label>
            <input
              type="text"
              class="form-control form-control-lg form-control-xl"
              placeholder
              required
              v-validate
              v-model.trim="owner_first_name"
              name="owner_first_name"
              data-vv-as="Owner's First Name"
            />
          </div>
          <div class="form-group">
            <label>Owner Doctor Last Name</label>
            <input
              type="text"
              class="form-control form-control-lg form-control-xl"
              placeholder
              required
              v-validate
              v-model.trim="owner_last_name"
              name="owner_last_name"
              data-vv-as="Owner's First Name"
            />
          </div>
          <div class="form-group">
            <label>Create password</label>
            <password-field v-model="password" />
          </div>
          <div class="alert alert-danger mb-0 mt-3" v-if="error">
            {{ error }}
          </div>
        </div>
        <div v-else></div>
      </div>
      <div class="modal-footer">
        <button v-if="isComplete" class="btn btn-primary" @click="isModalVisible = false">
          <font-awesome-icon icon="spinner-third" v-if="isSubmitting" spin />
          <span v-else>{{ ctaText }}</span>
        </button>
        <div v-else class="d-flex flex-column justify-content-end m-0">
          <div class="mb-3">
            <small class="text-muted">
              By continuing you agree to the
              <router-link to="/privacy-policy" target="_blank">Privacy Policy</router-link>,
              <router-link to="/terms-of-use" target="_blank">Terms of Use</router-link>
              and
              <router-link to="/business-agreement" target="_blank">Business Associate Agreement</router-link>
            </small>
          </div>
          <button class="btn btn-primary btn-lg btn-xl" @click="setPassword" :disabled="isSubmitting || !isFormValid">
            <font-awesome-icon icon="spinner-third" v-if="isSubmitting" spin />
            <span v-else>{{ ctaText }}</span>
          </button>
        </div>
      </div>
    </template>
  </modal>
</template>

<script>
import Modal from '@/components/Modal'
import PasswordField from '@/components/shared/PasswordFieldBootstrap'
import AcceptTocs from '@/components/shared/AcceptTocs'
import { mapState, mapGetters } from 'vuex'
export default {
  components: { Modal, PasswordField, AcceptTocs },
  data() {
    return {
      isModalVisible: true,
      isSubmitting: false,
      password: '',
      owner_first_name: '',
      owner_last_name: '',
      isComplete: false,
    }
  },
  computed: {
    ...mapState('auth', ['user', 'resetToken', 'error']),
    isPasswordValid() {
      return this.password.isValid
    },
    isFormValid() {
      return this.isPasswordValid && this.owner_first_name.length && this.owner_last_name.length
    },
    ctaText() {
      return this.$route.name === 'view-referral'
        ? 'View Referral'
        : this.$route.name === 'view-op-report'
        ? 'View Op Report'
        : 'Access My Refera Dashboard'
    },
  },
  mounted() {
    this.$store.dispatch('auth/clearError')
    this.owner_first_name = this.user.practice.owner_doctor_first
    this.owner_last_name = this.user.practice.owner_doctor_last
  },
  methods: {
    async setPassword() {
      this.isSubmitting = true
      try {
        await this.$store.dispatch('auth/activateFromGuest', {
          password: this.password.value,
          owner_first_name: this.owner_first_name,
          owner_last_name: this.owner_last_name,
        })
        await this.$store.dispatch('auth/me')
        await this.$store.dispatch('referrals/load', true)
        // this.user.practice.owner_doctor_first = this.owner_first_name;
        // this.user.practice.owner_doctor_last = this.owner_last_name;
        // await this.$store.dispatch('practices/save', this.user.practice);
        // this.user.first_name = this.owner_first_name;
        // this.user.last_name = this.owner_last_name;
        // await this.$store.dispatch('users/save', this.user);
        this.isModalVisible = false
        // this.isComplete = true
      } catch (err) {
        this.$exception(err)
      }
      this.isSubmitting = false
    },
  },
}
</script>
